import {graphql} from 'gatsby'
import React from 'react'

import FeatureBlock from '@/components/feature-block'
import type {LandingHeroSliceFragment} from '@/graphql-types'
import {isValidBackgroundColor} from '@/utils/is-valid-background-color'
import Button from '@helios/shared/components/button'
import PrismicLink from '@helios/shared/components/prismic-link'
import {BackgroundWrapper, Section} from '@helios/shared/styles/grid'

export const LandingHeroSlice = ({slice}: {slice: LandingHeroSliceFragment}) => {
    const color = isValidBackgroundColor(slice.primary.background)
        ? slice.primary.background
        : 'default'
    const ctaText = slice.primary.cta_text
    const ctaLink = slice.primary.cta_link

    return (
        <BackgroundWrapper color={color}>
            <Section padding="small">
                <FeatureBlock
                    image={slice.primary.image}
                    title={slice.primary.title}
                    body={slice.primary.lead_text.richText}
                    mirrored={!!slice.primary.inverse}
                    titleVariant="heading-large"
                    bodyProps={{variant: 'title-base'}}
                >
                    {ctaText && ctaLink && (
                        <Button as={PrismicLink} {...ctaLink}>
                            {ctaText}
                        </Button>
                    )}
                </FeatureBlock>
            </Section>
        </BackgroundWrapper>
    )
}

export const landingHeroSliceFragment = graphql`
    fragment LandingHeroSlice on PrismicSlicePageDataBodyLandingHero {
        __typename
        primary {
            title
            lead_text {
                richText
            }
            cta_text
            cta_link {
                ...PrismicLink
            }
            inverse
            background
            image {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
            }
        }
    }
`
